import keys from 'lodash/keys';

export abstract class BaseModel {
  constructor(options?: object) {
    keys(options).map(key => {
      this[key] = options[key];
    });
  }
}
